import type { Lang } from "../i18n";

export function formatMoney(amount?: number | null): string {
  if (amount == null || Number.isNaN(amount)) return "—";
  return `TSh ${Math.round(amount).toLocaleString("en-US")}`;
}

export function formatClock(iso: string | null | undefined, lang: Lang): string | null {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleTimeString(lang === "sw" ? "sw-TZ" : "en-GB", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function initials(name?: string): string {
  const parts = (name ?? "").trim().split(/\s+/).filter(Boolean);
  return ((parts[0]?.[0] ?? "") + (parts[1]?.[0] ?? "")).toUpperCase() || "?";
}

export function telHref(phone?: string): string | null {
  const digits = phone?.replace(/[^\d+]/g, "");
  return digits ? `tel:${digits}` : null;
}
